<template>
  <div class="battery_wrap_menu">
    <ui-tooltip v-show="description && showDescription" arrowTop arrowRight class="battery__description" :transitionType="'fade'">
      <span v-html="description"></span>
    </ui-tooltip>

    <div v-if="description" class="battery__description__type2">
      <p v-html="description"></p>
    </div>

    <div class="battery icon icon--battery clearfix"
         :class="{'empty': allSpend}"
         @mouseenter="showDescription = true"
         @mouseleave="showDescription = false">
      <div class="battery-filling" :style="getFillingStyle()"></div>
    </div>
  </div>
</template>

<script>
import UiTooltip from '@/components/ui/UiTooltip'
import { mapGetters } from 'vuex'

export default {
  name: 'BatteryIndicator',
  components: {
    UiTooltip
  },
  data () {
    return {
      showDescription: false
    }
  },
  props: {
    isLargeSize: {
      type: Boolean,
      required: false
    },
    description: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters([
      'creditData'
    ]),
    allSpend () {
      return this.creditData.hasPlan && !this.creditData.remain
    },
    batteryColor () {
      const value = this.creditData.percentage

      if (value < 30) {
        return '#e92020'
      } else if (value < 70) {
        return '#ffa200'
      } else {
        return '#70c9d8'
      }

      // eslint-disable-next-line no-unreachable
      throw new Error(`invalid battery percentage: ${this.creditData.percentage}`)
    }
  },
  methods: {
    getFillingStyle () {
      if (this.creditData.percentage) {
        let batterFillingDefaultWidth
        let percent = this.creditData.percentage > 100 ? 100 : this.creditData.percentage
        if (this.isLargeSize) {
          batterFillingDefaultWidth = `calc(${percent / 2}% + 7px)`
        } else {
          batterFillingDefaultWidth = `calc(${percent / 2}% + 3px)`
        }
        return {
          backgroundColor: this.batteryColor,
          width: batterFillingDefaultWidth
        }
      }
    }
  }
}
</script>

<style lang="scss">
.battery_wrap_menu {
  position: relative;
  display: inline-block;

  .battery {
    position: relative;
    cursor: pointer;
    vertical-align: middle;

    &:hover:after {
      display: block;
      content: '';
      width: 100%;
      height: 100%;
      background-color: #000;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0.06;
      border-radius: 50%;
    }

    .battery-filling{
      display: inline-block;
      position: absolute;
      top: 11px;
      left: 5px;
      height: 8px;
    }
  }

  .battery__description {
    position: absolute;
    z-index: 1;
    top: 42px;
    right: -5px;
  }

  .battery__description__type2 {
    display: inline-block;
    white-space: nowrap;
    vertical-align: middle;
    margin-right: 15px;

    strong {
      color: $brandColor;
      font-weight: 500;
    }
  }
 }
</style>
